import { withStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import './defaultTheme';
/* istanbul ignore next */

var styles = function styles(_ref) {
  var _ref$transitions = _ref.transitions,
      shorter = _ref$transitions.duration.shorter,
      easeInOut = _ref$transitions.easing.easeInOut;
  return {
    growY: {
      '&-enter': {
        transition: "transform ".concat(shorter, "ms ").concat(easeInOut),
        transformOrigin: 'top',
        display: 'block',
        transform: 'scaleY(0)'
      },
      '&-enter-active': {
        transform: 'scaleY(1)'
      },
      '&-enter-done': {
        display: 'block'
      },
      '&-exit': {
        transition: "transform ".concat(shorter, "ms ").concat(easeInOut),
        transformOrigin: 'top',
        display: 'block',
        transform: 'scaleY(1)'
      },
      '&-exit-active': {
        transform: 'scaleY(0)'
      },
      '&-exit-done': {
        display: 'none'
      }
    }
  };
};

export var GrowYComponent = function GrowYComponent(_ref2) {
  var children = _ref2.children,
      growY = _ref2.classes.growY,
      show = _ref2["in"],
      mountOnEnter = _ref2.mountOnEnter,
      shorter = _ref2.theme.transitions.duration.shorter,
      unmountOnExit = _ref2.unmountOnExit;
  return React.createElement(CSSTransition, {
    "in": show,
    classNames: growY,
    timeout: shorter,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit
  }, children);
};
GrowYComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func])), PropTypes.element, PropTypes.node, PropTypes.func]),
  classes: PropTypes.objectOf(PropTypes.string),
  mountOnEnter: PropTypes.bool,
  "in": PropTypes.bool,
  theme: PropTypes.shape({
    transitions: PropTypes.shape({
      duration: PropTypes.shape({
        shorter: PropTypes.number
      })
    })
  }),
  unmountOnExit: PropTypes.bool
};
GrowYComponent.defaultProps = {
  children: [],
  classes: {},
  mountOnEnter: true,
  "in": false,
  theme: {},
  unmountOnExit: true
};
var GrowYStyled = withStyles(styles)(GrowYComponent);
export default withTheme(GrowYStyled);